// Shared redirect when Platform is closed for non-ACTIVE tenants.
import { TenantStatus } from 'types/accessManager.type';
import { UserRole, UserRoleType } from 'types/userRoles';

export const ONBOARDING_BASE_URL = process.env.REACT_APP_ONBOARDING_URL || 'https://onboarding.slai.com';

export const TENANT_NOT_ACTIVE_CODE = 'TENANT_NOT_ACTIVE';

export function shouldRedirectToOnboarding(
    tenantStatus: string | undefined | null,
    userRoles: UserRoleType[] | undefined | null
): boolean {
    const roles = userRoles ?? [];
    if (roles.includes(UserRole.SUPER_ADMIN)) {
        return false;
    }
    return tenantStatus !== TenantStatus.ACTIVE;
}

export function redirectToOnboarding(): void {
    window.location.assign(ONBOARDING_BASE_URL);
}
